import React from 'react';
import { Button, ModalHeader } from '../../components/Bootstrap';
import { DateField } from './DateField';
import { OnboardingStep } from './types';
import { Form, FormProps } from '../../components';

const transformErrors = (errors) => {
  return errors.map((error) => {
    if (error.property === '.phone' && error.name === 'pattern') {
      error.message = 'Please make sure your number is in the format (xxx) xxx xxxx.';
    } else if (error.property === '.zip' && error.name === 'pattern') {
      error.message = 'Please check the format';
    } else if (error.name === 'required') {
      error.message = 'This is required.';
    }

    return error;
  });
};

interface VenueFormWizardProps {
  data: any;
  step: OnboardingStep;
  isOnFirstStep: boolean;
  isOnLastStep: boolean;
  onSubmitStep(): void;
  onSaveForLater();
  onChange(step, data);
  onStepBack();
}

const identity = (x) => x;

export class VenueFormWizard extends React.Component<VenueFormWizardProps, {}> {
  onChange = ({ formData }) => {
    const preprocess = this.props.step.preprocess || identity;
    this.props.onChange(this.props.step.key, preprocess(formData));
  };

  render() {
    const { step } = this.props;
    const { schema, uiSchema } = step;

    const props: FormProps = {
      uiSchema,
      onSubmit: this.props.onSubmitStep,
      onChange: this.onChange,
      formData: this.props.data,
      schema,
      transformErrors,
      className: 'onboarding-info-form' + (step.slim ? ' slim' : ''),
      fields: {
        datepicker: DateField,
      },
    };

    let prevButton;
    if (!this.props.isOnFirstStep) {
      prevButton = (
        <Button type='button' color='link' className='me-3' onClick={this.props.onStepBack}>
          Previous
        </Button>
      );
    }

    const nextButtonTitle = this.props.isOnLastStep ? 'Submit' : 'Next';

    return (
      <div>
        <ModalHeader className='justify-content-center'>{step.header}</ModalHeader>
        <Form {...props}>
          <div className='mt-5 text-center'>
            {prevButton}
            <Button type='submit' color='primary' className='btn--rounded-padded'>
              {nextButtonTitle}
            </Button>
          </div>
          <div className='text-center'>
            <Button type='button' onClick={this.props.onSaveForLater} className='save-for-later-btn' color='link'>
              Save for later
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
